import { PlusOutlined } from "@ant-design/icons"
import { Button, Typography } from "antd"
import { memo } from "react"

import Flex from "#blocks/Flex"

import { type PortfolioMockProject } from "./usePortfolioDbStorage"

const { Text } = Typography

interface TimelineSectionHeaderProps {
  category: PortfolioMockProject["category"]
  label: string
  countLabel: string
  isOverLimit: boolean
  categoryTextColorMap: Record<PortfolioMockProject["category"], string>
  onAddProject?: () => void
}

const TimelineSectionHeader = memo(
  ({
    category,
    label,
    countLabel,
    isOverLimit,
    categoryTextColorMap,
    onAddProject,
  }: TimelineSectionHeaderProps) => (
    <Flex gap={8} style={{ alignItems: "center" }}>
      <Text
        style={{
          fontSize: 15,
          fontWeight: 600,
          color: categoryTextColorMap[category],
        }}
      >
        {label}
      </Text>
      <Text
        style={{
          fontSize: 14,
          color: isOverLimit ? "#cf1322" : categoryTextColorMap[category],
          fontWeight: 600,
        }}
      >
        ({countLabel})
      </Text>
      {onAddProject && (
        <Button
          icon={<PlusOutlined />}
          size="small"
          type="text"
          onClick={(event) => {
            event.stopPropagation()
            onAddProject()
          }}
          title="Add project"
        />
      )}
    </Flex>
  )
)

TimelineSectionHeader.displayName = "TimelineSectionHeader"

export default TimelineSectionHeader
